import ErrorMessage from './ErrorMessage';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useT } from '@hooks/useT';

function GenericServerError() {
  const { t } = useT('errors');

  return (
    <ErrorMessage
      title={t('general.serverError')}
      message={t('general.serverErrorMessage')}
      icon={<ErrorOutlineIcon />}
      severity="error"
    />
  );
}

export default GenericServerError;
